// (() => {
//   'use strict';

//   /*
//    * Product-card containers used by Horizon and custom Ciara sections.
//    */
//   const CARD_SELECTOR = [
//     'product-card',
//     '.product-card',
//     '.product-card-wrapper',
//     '.product-grid__item',
//     '.resource-list__item',
//     '[data-product-card]',
//     '[data-product-id]'
//   ].join(',');

//   /*
//    * Product-title wrappers used by Horizon dynamic blocks.
//    */
//   const TITLE_SELECTOR = [
//     '[class*="__product_title_"]',
//     '[class*="__product-title_"]',
//     '.product-card__title',
//     '.product-title',
//     '[data-product-title]'
//   ].join(',');

//   /*
//    * Each group is equalized separately.
//    * This prevents one section from affecting another section.
//    */
//   const GROUP_SELECTOR = [
//     '#ResultsList',
//     '.product-grid',
//     'product-grid',
//     '.resource-list',
//     'resource-list',
//     'slideshow-component',
//     '.slideshow',
//     '[data-testid="resource-list-grid"]',
//     '[data-ciara-track]',
//     '.ciara-product-carousel',
//     '.section-resource-list'
//   ].join(',');

//   let updateTimer = null;
//   let updateFrame = null;

//   /**
//    * Find the title wrapper inside a product card.
//    */
//   function getCardTitle(card) {
//     if (!(card instanceof HTMLElement)) return null;

//     const title = card.querySelector(TITLE_SELECTOR);

//     return title instanceof HTMLElement ? title : null;
//   }

//   /**
//    * Find the nearest product-list or slider container.
//    */
//   function getCardGroup(card) {
//     const group = card.closest(GROUP_SELECTOR);

//     if (group instanceof HTMLElement) {
//       return group;
//     }

//     /*
//      * Fallback for custom product-card layouts.
//      */
//     if (card.parentElement instanceof HTMLElement) {
//       return card.parentElement;
//     }

//     return null;
//   }

//   /**
//    * Return only unique product cards.
//    *
//    * A resource-list item may contain another element matching the card
//    * selector, so duplicate title elements are removed later.
//    */
//   function getAllProductCards(scope = document) {
//     return Array.from(scope.querySelectorAll(CARD_SELECTOR)).filter(
//       (card) => card instanceof HTMLElement
//     );
//   }

//   /**
//    * Reset all previously applied title heights.
//    */
//   function resetTitleHeight(title) {
//     title.style.removeProperty('height');
//     title.style.removeProperty('min-height');
//     title.style.setProperty('box-sizing', 'border-box');
//   }

//   /**
//    * Equalize product titles inside one product group.
//    */
//   function equalizeGroup(group, cards) {
//     if (!(group instanceof HTMLElement) || !cards.length) return;

//     const titleSet = new Set();

//     cards.forEach((card) => {
//       const title = getCardTitle(card);

//       if (title) {
//         titleSet.add(title);
//       }
//     });

//     const titles = Array.from(titleSet);

//     if (titles.length < 2) {
//       titles.forEach(resetTitleHeight);
//       return;
//     }

//     /*
//      * Remove old heights before measuring natural content height.
//      */
//     titles.forEach(resetTitleHeight);

//     let maximumHeight = 0;

//     titles.forEach((title) => {
//       /*
//        * Ignore elements hidden through display:none.
//        */
//       if (title.getClientRects().length === 0) return;

//       const rectHeight = title.getBoundingClientRect().height;
//       const contentHeight = title.scrollHeight;

//       maximumHeight = Math.max(
//         maximumHeight,
//         Math.ceil(rectHeight),
//         Math.ceil(contentHeight)
//       );
//     });

//     if (maximumHeight <= 0) return;

//     titles.forEach((title) => {
//       title.style.setProperty('height', `${maximumHeight}px`);
//       title.style.setProperty('min-height', `${maximumHeight}px`);
//       title.style.setProperty('box-sizing', 'border-box');
//     });
//   }

//   /**
//    * Group cards by their nearest product grid or carousel.
//    */
//   function equalizeAllProductTitles() {
//     const cards = getAllProductCards();
//     const groups = new Map();

//     cards.forEach((card) => {
//       const title = getCardTitle(card);
//       if (!title) return;

//       const group = getCardGroup(card);
//       if (!group) return;

//       if (!groups.has(group)) {
//         groups.set(group, []);
//       }

//       groups.get(group).push(card);
//     });

//     groups.forEach((groupCards, group) => {
//       equalizeGroup(group, groupCards);
//     });
//   }

//   /**
//    * Run after the browser completes current DOM and layout changes.
//    */
//   function scheduleEqualization(delay = 80) {
//     window.clearTimeout(updateTimer);

//     updateTimer = window.setTimeout(() => {
//       if (updateFrame) {
//         window.cancelAnimationFrame(updateFrame);
//       }

//       updateFrame = window.requestAnimationFrame(() => {
//         /*
//          * A second frame allows width and line wrapping to settle after
//          * AJAX section replacement or carousel initialization.
//          */
//         window.requestAnimationFrame(() => {
//           equalizeAllProductTitles();
//         });
//       });
//     }, delay);
//   }

//   /**
//    * Initial setup.
//    */
//   function initializeEqualProductTitles() {
//     scheduleEqualization(0);

//     /*
//      * Custom fonts can alter title wrapping and height.
//      */
//     if (document.fonts?.ready) {
//       document.fonts.ready
//         .then(() => {
//           scheduleEqualization(0);
//         })
//         .catch(() => {
//           /* Font-loading errors do not affect the page. */
//         });
//     }

//     window.addEventListener(
//       'load',
//       () => {
//         scheduleEqualization(0);
//       },
//       { once: true }
//     );
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener(
//       'DOMContentLoaded',
//       initializeEqualProductTitles,
//       { once: true }
//     );
//   } else {
//     initializeEqualProductTitles();
//   }

//   /*
//    * Recalculate after viewport or card-width changes.
//    */
//   window.addEventListener('resize', () => {
//     scheduleEqualization(150);
//   });

//   window.addEventListener('orientationchange', () => {
//     scheduleEqualization(200);
//   });

//   /*
//    * Shopify Theme Editor support.
//    */
//   document.addEventListener('shopify:section:load', () => {
//     scheduleEqualization(50);
//   });

//   document.addEventListener('shopify:section:reorder', () => {
//     scheduleEqualization(50);
//   });

//   document.addEventListener('shopify:block:select', () => {
//     scheduleEqualization(50);
//   });

//   /*
//    * Support the custom Ciara AJAX collection tabs.
//    */
//   document.addEventListener('ciara:collection:loaded', () => {
//     scheduleEqualization(50);
//   });

//   /*
//    * Detect AJAX products, infinite-scroll products, slider clones,
//    * changed titles, and dynamically rebuilt Horizon sections.
//    */
//   const mutationObserver = new MutationObserver((mutations) => {
//     const hasRelevantChange = mutations.some((mutation) => {
//       if (mutation.type === 'characterData') {
//         return Boolean(
//           mutation.target.parentElement?.closest(TITLE_SELECTOR)
//         );
//       }

//       if (mutation.type !== 'childList') return false;

//       const changedNodes = [
//         ...mutation.addedNodes,
//         ...mutation.removedNodes
//       ];

//       return changedNodes.some((node) => {
//         if (!(node instanceof Element)) return false;

//         return (
//           node.matches(CARD_SELECTOR) ||
//           node.matches(TITLE_SELECTOR) ||
//           node.querySelector(CARD_SELECTOR) !== null ||
//           node.querySelector(TITLE_SELECTOR) !== null
//         );
//       });
//     });

//     if (hasRelevantChange) {
//       scheduleEqualization(80);
//     }
//   });

//   mutationObserver.observe(document.body, {
//     childList: true,
//     subtree: true,
//     characterData: true
//   });
// })();











(() => {
  const initGiftMessage = (giftMessage) => {
    if (
      giftMessage.dataset.giftMessageInitialized === 'true'
    ) {
      return;
    }

    const toggle = giftMessage.querySelector(
      '[data-gift-message-toggle]'
    );

    const field = giftMessage.querySelector(
      '[data-gift-message-field]'
    );

    const textarea = giftMessage.querySelector(
      '[data-gift-message-textarea]'
    );

    const count = giftMessage.querySelector(
      '[data-gift-message-count]'
    );

    const limitElement = giftMessage.querySelector(
      '[data-gift-message-limit]'
    );

    if (!toggle || !field || !textarea) {
      return;
    }

    giftMessage.dataset.giftMessageInitialized = 'true';

    /*
     * Get character limit from Shopify Theme Settings
     */
    const characterLimit =
      parseInt(
        giftMessage.dataset.characterLimit,
        10
      ) || 200;

    if (limitElement) {
      limitElement.textContent = characterLimit;
    }

    /*
     * Character counter
     */
    const updateCharacterCount = () => {
      if (count) {
        count.textContent = textarea.value.length;
      }
    };

    /*
     * Checkbox
     */
    toggle.addEventListener('change', () => {
      const enabled = toggle.checked;

      /*
       * Show / hide textarea
       */
      field.hidden = !enabled;

      /*
       * IMPORTANT:
       * When enabled, textarea will be included
       * in the product form submission.
       */
      textarea.disabled = !enabled;

      toggle.setAttribute(
        'aria-expanded',
        enabled ? 'true' : 'false'
      );

      if (!enabled) {
        textarea.value = '';
      }

      updateCharacterCount();

      if (enabled) {
        textarea.focus();
      }
    });

    /*
     * Character counter
     */
    textarea.addEventListener(
      'input',
      updateCharacterCount
    );

    /*
     * Initial state
     */
    field.hidden = !toggle.checked;
    textarea.disabled = !toggle.checked;

    updateCharacterCount();
  };

  /*
   * Initialize all Gift Message blocks
   */
  const initializeGiftMessages = () => {
    document
      .querySelectorAll('[data-gift-message]')
      .forEach(initGiftMessage);
  };

  /*
   * Initial page load
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeGiftMessages
    );
  } else {
    initializeGiftMessages();
  }

  /*
   * Horizon can dynamically re-render
   * product sections.
   */
  const observer = new MutationObserver(() => {
    initializeGiftMessages();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();